<template>
    <div class="dashboard-item">
        <p>
            <a :href="getItemUrl(item.id)" @click.prevent="itemClick(item.id)">{{item.text}}</a>
        </p>
        <span class="dashboard-item-section" v-bind:class="item.type + '-mark'">{{getTypeTitle(item.type)}}</span>
        <controls-dropdown @click="clickControls" :visible-controls="visibleControlsId" :actions="actions" :item-id="item.id"></controls-dropdown>
        <span v-if="draggable" class="draggable-icon handle">
             <svg width="10" height="16" viewBox="0 0 10 16" fill="none"><path
                     d="M0 4H4V0H0V4ZM6 16H10V12H6V16ZM0 16H4V12H0V16ZM0 10H4V6H0V10ZM6 10H10V6H6V10ZM6 4H10V0H6V4Z"
                     fill="#e0e2e5"/></svg>
        </span>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import ControlsDropdown from "./ControlsDropdown";

    export default {
        name: 'dashbord-dropdown-item',
        components: {
            ControlsDropdown,
        },
        props: {
            item: Object,
            draggable: {
                type: Boolean,
                default: false
            },
            actions: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        computed: {
            ...mapState({
                types: state => state.main.types,
                visibleControlsId: state => state.main.visibleControlsId
            }),
            showControls() {
                return this.visibleControlsId === this._uid;
            },
        },
        methods: {
            ...mapMutations('main', [
                'setControlsVisibility'
            ]),
            getTypeTitle(type) {
                return this.types.find(x => (type === x.type)).name
            },
            itemClick(id) {
                //this.$store.dispatch('knowledge/getPost', id);
                this.$router.push('/knowledge-base/'+ id).catch(() => {
                    //console.log(err);
                })
            },
            clickControls(e) {
                if (this.visibleControlsId !== e) {
                    this.setControlsVisibility(e);
                } else {
                    this.setControlsVisibility(null);
                }
            },
            getItemUrl(id) {
                return '/knowledge-base/' + id;
            }
        },

    }
</script>

<style scoped>

</style>
